function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Image, Label, Stack, Link } from "@fluentui/react";
import DismissButton from "./subcomponents/DismissButton";
import CloseChatButton from "./subcomponents/CloseChatButton";
import { decodeComponentString } from "../../common/decodeComponentString";
import { Ids } from "../../common/Constants";

function NotificationPane(props) {
  var _props$componentOverr, _props$componentOverr2, _props$componentOverr3, _props$componentOverr4, _props$componentOverr5, _props$dismissButtonP, _props$closeChatButto;

  const elementId = props.id ?? Ids.DefaultNotificationPaneId;
  const containerStyles = {
    root: Object.assign({}, props.generalStyleProps)
  };
  const titleStyles = {
    root: Object.assign({}, props.titleStyleProps)
  };
  const subtitleStyles = {
    root: Object.assign({}, props.subtitleStyleProps)
  };
  const hyperlinkStyles = {
    root: Object.assign({}, props.hyperlinkStyleProps)
  };
  const hyperlinkHoverStyles = {
    root: Object.assign({}, props.hyperlinkHoverStyleProps)
  };
  const notificationIconProps = Object.assign({}, props.notificationIconProps);
  const notificationIconStyles = Object.assign({}, props.notificationIconStyleProps);
  const notificationIconImageStyles = {
    root: {},
    image: notificationIconStyles
  };
  const notificationIconContainerStyles = {
    root: Object.assign({}, props.notificationIconContainerStyleProps)
  };
  const dismissButtonProps = Object.assign({}, props.dismissButtonProps);
  const dismissButtonStyles = Object.assign({}, props.dismissButtonStyleProps);
  const dismissButtonHoverStyles = Object.assign({}, props.dismissButtonHoverStyleProps);
  const closeChatButtonProps = Object.assign({}, props.closeChatButtonProps);
  const closeChatButtonStyles = Object.assign({}, props.closeChatButtonStyleProps);
  const closeChatButtonHoverStyles = Object.assign({}, props.closeChatButtonHoverStyleProps);
  const infoGroupStyles = {
    root: Object.assign({}, props.infoGroupStyleProps)
  };
  const buttonGroupStyles = {
    root: Object.assign({}, props.buttonGroupStyleProps)
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    className: props.containerClassName,
    styles: containerStyles,
    id: elementId,
    dir: props.dir ?? "ltr",
    tabIndex: -1,
    role: "presentation"
  }, /*#__PURE__*/React.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "space-between",
    styles: containerStyles,
    dir: props.dir ?? "ltr"
  }, /*#__PURE__*/React.createElement(Stack, {
    styles: notificationIconContainerStyles
  }, !props.hideNotificationIcon && (decodeComponentString((_props$componentOverr = props.componentOverrides) === null || _props$componentOverr === void 0 ? void 0 : _props$componentOverr.notificationIcon) || /*#__PURE__*/React.createElement(Image, {
    className: notificationIconProps.className,
    id: notificationIconProps.id,
    src: notificationIconProps.src,
    alt: notificationIconProps.alt,
    tabIndex: -1,
    styles: notificationIconImageStyles
  }))), /*#__PURE__*/React.createElement(Stack, {
    styles: infoGroupStyles,
    dir: props.dir ?? "ltr"
  }, !props.hideTitle && (decodeComponentString((_props$componentOverr2 = props.componentOverrides) === null || _props$componentOverr2 === void 0 ? void 0 : _props$componentOverr2.title) || /*#__PURE__*/React.createElement(Label, {
    className: props.titleClassName,
    styles: titleStyles,
    tabIndex: -1,
    id: elementId + "-title"
  }, props.titleText)), !props.hideSubtitle && (decodeComponentString((_props$componentOverr3 = props.componentOverrides) === null || _props$componentOverr3 === void 0 ? void 0 : _props$componentOverr3.subtitle) || /*#__PURE__*/React.createElement(Label, {
    className: props.subtitleClassName,
    styles: subtitleStyles,
    tabIndex: -1,
    id: elementId + "-subtitle"
  }, props.subtitleText)), !props.hideHyperlink && (decodeComponentString((_props$componentOverr4 = props.componentOverrides) === null || _props$componentOverr4 === void 0 ? void 0 : _props$componentOverr4.hyperlink) || /*#__PURE__*/React.createElement(Link, {
    className: props.hyperlinkClassName,
    ariaLabel: props.hyperlinkAriaLabel,
    id: elementId + "-hyperlink",
    styles: hyperlinkStyles,
    hoverStyles: hyperlinkHoverStyles,
    target: "_blank",
    rel: "noopener noreferrer",
    href: props.hyperlinkHref
  }, props.hyperlinkText))), !props.hideDismissButton && (decodeComponentString((_props$componentOverr5 = props.componentOverrides) === null || _props$componentOverr5 === void 0 ? void 0 : _props$componentOverr5.dismissButton) || /*#__PURE__*/React.createElement(DismissButton, _extends({}, dismissButtonProps, {
    className: props.dismissButtonClassName,
    onClick: (_props$dismissButtonP = props.dismissButtonProps) === null || _props$dismissButtonP === void 0 ? void 0 : _props$dismissButtonP.onClick,
    styles: dismissButtonStyles,
    hoverStyles: dismissButtonHoverStyles
  })))), /*#__PURE__*/React.createElement(Stack, {
    horizontal: true,
    styles: buttonGroupStyles,
    dir: props.dir ?? "ltr"
  }, !props.hideCloseChatButton && /*#__PURE__*/React.createElement(CloseChatButton, _extends({}, closeChatButtonProps, {
    className: props.closeChatButtonClassName,
    onClick: (_props$closeChatButto = props.closeChatButtonProps) === null || _props$closeChatButto === void 0 ? void 0 : _props$closeChatButto.onClick,
    styles: closeChatButtonStyles,
    hoverStyles: closeChatButtonHoverStyles
  })))));
}

export default NotificationPane;